import { render, staticRenderFns } from "./PrecificationCard.vue?vue&type=template&id=6fc0ed5a&"
import script from "./PrecificationCard.vue?vue&type=script&lang=js&"
export * from "./PrecificationCard.vue?vue&type=script&lang=js&"
import style0 from "./PrecificationCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports